import { withStyles } from '@material-ui/core';

import AddButton from './component';
import styles from './styles';

export default withStyles(styles)(AddButton);
